<template>
  <main>
    <router-view></router-view>
  </main>
</template>

<script>
export default {
  name: "App",
  data: () => ({}),
  components: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  font-family: "Inter Variable", sans-serif;
}
</style>
